import React, { useEffect } from "react";
import "./About.css";
import AboutCard from "./AboutCards";
import CustomButton from "./Custombtn"
import { Link } from "react-scroll";
import Education from "./Education";
import Aos from "aos";
import "aos/dist/aos.css";
import Experience from "./Experience";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
function About() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const pdfUrl = process.env.PUBLIC_URL + "/Harsh_Agrawal.pdf";
  const handleDownload = () => {
    console.log("function called");
    const anchor = document.createElement("a");
    anchor.href = pdfUrl;
    anchor.target = "_blank";
    anchor.download = "Harsh_Agrawal.pdf";
    anchor.click();
  };

  return (
    <div className="App">
      <div className="maincontainer">
        <div className="img-container">
          <img
            src={process.env.PUBLIC_URL + "/user.jpg"}
            alt="Is not displayed"
            className="user-img"
          />
        </div>
        <div className="details-div">
          <p className="firsttext">Hi There,</p>
          <p className="second-text">
            I'm Harsh <span className="secondname">Agrawal</span>
          </p>
          <p className="about-details">
            Well-qualified Full Stack Developer familiar with wide range of
            programming utilities and languages. Knowledgeable of backend and
            frontend development requirements. Handles any part of process with
            ease. Collaborative team player with excellent technical abilities
            offering Number years of related experience. I Want to Make
            Commendable Contribution in the Field of Computer Science.
          </p>
          <div className="aboutbtn">
            <Link to="about-section" smooth={true} duration={500}>
              <CustomButton btntitle="More Info" />
            </Link>
          </div>
        </div>
      </div>
      <p id="about-section" className="about-section">
        About
      </p>
      <AboutCard data-aos="fade-up" />
      <p className="about-section" data-aos="fade-up">
        Education
      </p>
      <div className="education-details">
        <Education
          data-aos="fade-up"
          collegedetails="O.P Jindal School"
          board="Class 10th, High School/Secondary"
          year="May 2018"
          grade="91%"
          activities="Activities and societies: Literacy Club , Cultural Club , British Council, House Captain"
          imglink="https://media.istockphoto.com/id/1319938106/vector/school-building-facade-with-green-grass-and-trees-public-educational-institution-exterior.jpg?s=612x612&w=0&k=20&c=DwOHvs1pe1DemAymxwS6qg7nrgTw0CwLum_sqfB-H3U="
        />
        <Education
          data-aos="fade-up"
          collegedetails="O.P Jindal School"
          board="Class 12th / Higher secondary"
          year="May 2018 - Apr 2020"
          grade="96%"
          activities="Activities and societies: Cricket Team, Marching Band"
          imglink="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSz6Xey8GsoLJn4Fv55iws4C25i-zANlYNLMg&usqp=CAU"
        />
        <Education
          data-aos="fade-up"
          collegedetails="O.P Jindal University"
          board="Bachelor of Technology - BTech, Computer ScienceBachelor of Technology - BTech, Computer Science"
          year="Sep 2020 - Jun 2024Sep 2020 - Jun 2024"
          grade="9.1 CGPA"
          activities="Activities and societies: Coding Camps , Bootcamps , Technical Conferences/Activities and societies: CodingCamps , Bootcamps , Technical Conferences
          Application Development, Software Engineer"
          imglink="https://img.freepik.com/free-photo/harvard-university-cambridge-usa_1268-14363.jpg"
        />
      </div>
      <p className="about-section">Experience</p>
      <div className="experience">
        <Experience
          role="Software Developer"
          type="Fydo · Internship"
          year="Aug 2022 - Dec 2022 · 5 mos"
          place="Bhubaneswar, Odisha, India"
          href="https://www.linkedin.com/company/fydoin/"
          description="App Development Intern at Fydo formerly Lfyd Services ltd, Worked in
            Multiple Technologies and Deployment multiple web pages which
            includes addition of multiple functionality and features."
          imglink="https://play-lh.googleusercontent.com/a2lrdBkAS-ExKl4K_G1iyt12lkzmky8Nc_rniFRX_7JVckRFSYQ6y9muxr758vjMjUtw"
        />
        <Experience
          role="Full Stack Developer"
          type="SARTHAK TECHNOLOGIES PRIVATE LIMITED · Internship"
          year="Jan 2023 - Apr 2023 · 4 mos"
          href="https://www.linkedin.com/company/sarthak-technologies-private-limited/about/"
          place="Korba, Chhattisgarh, India · Remote"
          description="Created Multiple Projects for Clients based upon requirements using Technology such as React , JavaScript, JSX, Nodejs, Mongodb."
          imglink="data:image/jpeg;base64,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"
        />
        <Experience
          role="Software Developer (React)"
          type="vookad · Internship"
          href="https://www.linkedin.com/company/vookad/"
          year="May 2023 - Jul 2023 · 3 mos"
          place="Bhubaneswar, Odisha, India · Hybrid"
          description="Developed new user-facing features using React.js

        Building reusable components and front-end libraries for future use
        
        Translating designs and wireframes into high quality code
        
        Optimizing components for maximum performance across a vast array of web-capable devices and browsers"
          imglink="https://media.licdn.com/dms/image/C560BAQE-7BBhB5GDFQ/company-logo_200_200/0/1678740280803?e=1702512000&v=beta&t=2gsurAikj1lU_NJE8yHAbYRiwa_9H1UmxdX9qGq_kW4"
        />
        <Experience
          role="Full Stack Developer"
          type="Freelancer.com · Freelance"
          year="Apr 2020 - Present · 3 yrs 6 mos"
          place="Remote"
          href="https://www.linkedin.com/company/freelancer-com/"
          imglink="https://media.licdn.com/dms/image/C560BAQEJe-MEhPTm7w/company-logo_200_200/0/1519897752927?e=1702512000&v=beta&t=w3klbirIATTDGAMGwi6lzJ72zrQaxd2vhTy7ETAYQdE"
        />
        <Experience
          role="Senior Associate"
          type="IEEE · Full-time"
          year="Jan 2023 - Present · 9 mos"
          place="On-site"
          href="https://www.linkedin.com/company/ieee/"
          imglink="https://media.licdn.com/dms/image/C4E0BAQGoRdJYxmIDhQ/company-logo_200_200/0/1519856132409?e=1702512000&v=beta&t=-sX7GXd2XVR4YixySEzZamyjPvJYoCrANpL5ox_8NsQ"
        />
        <Experience
          role="Google Arcade Cloud Program "
          type="Google · Full-time"
          year="Jul 2023 - Present · 3 mos"
          place="On-site"
          href="https://www.linkedin.com/company/google/"
          imglink="https://media.licdn.com/dms/image/C4D0BAQHiNSL4Or29cg/company-logo_200_200/0/1519856215226?e=1702512000&v=beta&t=2zem4OTGbN0eppn_otTcCbbTi3BsZ3Pl6Gy8Ce5eluQ"
        />
        <Experience
          role="Campus Ambassador"
          type="StockGro · Internship"
          year="Aug 2023 - Present · 2 mos"
          place="Remote"
          href="https://www.linkedin.com/company/stockgro/"
          description="BigShot 2.0 Intern : Stock Market Analysis, Event Onboarding, Spreading Awareness about Finance and Economics"
          imglink="https://media.licdn.com/dms/image/C560BAQGO89NR8CCo1w/company-logo_200_200/0/1673523491547?e=1702512000&v=beta&t=7HaWykH3qTL1XEuGFJHnaCvYd8L5jtVTs2fNjMR3hv0"
        />
        <Experience
          role="Founder"
          type="TechCross · Full-time"
          href="https://www.linkedin.com/search/results/all/?keywords=TechCross&sid=Jy!"
          year="Sep 2023 - Present · 1 mo"
          place="Raigarh, Chhattisgarh, India · On-site"
          description="Founder and CEO at TechCross Startup Pvt. Ltd."
          imglink="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMcvzGGtAW2lCww7n8vH_wsvfYkT11648d0fgX8Cv-azue5rE30tJiLb82iYjumgKZcs8&usqp=CAU"
        />
      </div>
      <div className="resume-section">
        <p className="about-section">Resume</p>
        <div className="resume-btn">
          <buttton onClick={handleDownload} className="resumedownload">Click here to Download</buttton>
        </div>
      </div>
    </div>
  );
}

export default About;
